export default {
  QueryAdByPosition: 'AD/AD.QueryAdByPosition'
}